import instance from "../axios";

const products = {
  state: () => ({
    products: [],
    filteredProducts: [],
    searchQuery: "",
    filters: {
      category: null,
      type: null,
      minPrice: null,
      maxPrice: null,
    },
  }),

  mutations: {
    SET_PRODUCTS(state, data) {
      // Handle different response formats from API
      if (Array.isArray(data)) {
        state.products = data;
      } else if (data && data.data && Array.isArray(data.data)) {
        state.products = data.data;
      } else {
        state.products = [];
      }
    },
    SET_FILTERED_PRODUCTS(state, data) {
      state.filteredProducts = data;
    },
    SET_SEARCH_QUERY(state, query) {
      state.searchQuery = query;
    },
    SET_FILTERS(state, filters) {
      state.filters = { ...state.filters, ...filters };
    },
  },

  actions: {
    async fetchProducts({ commit }) {
      try {
        const res = await instance.get("products");
        commit("SET_PRODUCTS", res.data);
        return res.data;
      } catch (err) {
        console.error("Error fetching products", err);
        return [];
      }
    },

    async createProduct(t, data) {
      const form = new FormData();      
      // Append multiple files
      data.images.forEach(file => form.append("images", file));
      try {
        const fRes = await instance.post("products/upload", form);

        if (fRes.status !== 201) {
          return { message: "Photo upload failed" };
        }

        data.images = fRes.data.images;
        data.price = data.price.toString();
        data.quantity = data.quantity.toString();

        const res = await instance.post("products/create", data);
        if (res.status !== 201) {
          return { message: "Product creation failed" };
        }
        return res.status;
      } catch (err) {
        return {
          message: "Error creating product",
          error: err
        };
      }
    },
    async getProducts() {
      try {
        const res = await instance.get("products");
        return res;
      } catch (err) {
        return err;
      }
    },
    async getProductById(r, id) {
      try {
        const res = await instance.get(`/products/single/${id}`);

        return res;
      } catch (err) {
        return err;
      }
    },
    async getProductByType(t, type) {
      try {
        const res = await instance.get(`/products/type/${type}`);

        return res;
      } catch (err) {
        return err;
      }
    },
    async deleteProductById(t, id) {
      try {
        const res = await instance.delete(`products/${id}`);
        return res;
      } catch (err) {
        return err;
      }
    },
    async updateProduct(t, data) {
      try {
        data.price = data.price.toString();
        data.quantity = data.quantity.toString();
        const res = await instance.put(`products/update/${data.id}`, data);
        return res;
      } catch (err) {
        return err;
      }
    },
    async updateCover(t, data) {
      const form = new FormData();      
      // Append multiple files
      data.images.forEach(file => form.append("images", file));

      try {
        const fRes = await instance.post("products/upload", form);
        if (fRes.status !== 201) return { message: "file not valid" };

        // console.log(fRes.data);

        // const res = await instance.put(`products/update/cover/${data.id}`, {
        //   images: fRes.data.images[0],
        // });

        return fRes.status;
      } catch (err) {
        return err;
      }
    },

    async searchProducts({ commit }, query) {
      try {
        const res = await instance.get("products/search", {
          params: { q: query },
        });
        commit("SET_FILTERED_PRODUCTS", res.data);
        commit("SET_SEARCH_QUERY", query);
        return res.data;
      } catch (err) {
        console.error("Error searching products", err);
        return [];
      }
    },

    async filterByCategory({ commit }, category) {
      try {
        const res = await instance.get("products/filter/category", {
          params: { category },
        });
        commit("SET_FILTERED_PRODUCTS", res.data);
        commit("SET_FILTERS", { category });
        return res.data;
      } catch (err) {
        console.error("Error filtering by category", err);
        return [];
      }
    },

    async filterByType({ commit }, type) {
      try {
        const res = await instance.get("products/filter/type", {
          params: { type },
        });
        commit("SET_FILTERED_PRODUCTS", res.data);
        commit("SET_FILTERS", { type });
        return res.data;
      } catch (err) {
        console.error("Error filtering by type", err);
        return [];
      }
    },

    async filterByPrice({ commit }, { minPrice, maxPrice }) {
      try {
        const res = await instance.get("products/filter/price", {
          params: { minPrice, maxPrice },
        });
        commit("SET_FILTERED_PRODUCTS", res.data);
        commit("SET_FILTERS", { minPrice, maxPrice });
        return res.data;
      } catch (err) {
        console.error("Error filtering by price", err);
        return [];
      }
    },

    async advancedFilter({ commit }, filters) {
      try {
        const params = {};
        if (filters.search) params.search = filters.search;
        if (filters.category) params.category = filters.category;
        if (filters.type) params.type = filters.type;
        if (filters.minPrice) params.minPrice = filters.minPrice;
        if (filters.maxPrice) params.maxPrice = filters.maxPrice;

        const res = await instance.get("products/filter/advanced", { params });
        commit("SET_FILTERED_PRODUCTS", res.data);
        commit("SET_FILTERS", filters);
        return res.data;
      } catch (err) {
        console.error("Error with advanced filter", err);
        return [];
      }
    },

    clearFilters({ commit }) {
      commit("SET_FILTERED_PRODUCTS", []);
      commit("SET_SEARCH_QUERY", "");
      commit("SET_FILTERS", {
        category: null,
        type: null,
        minPrice: null,
        maxPrice: null,
      });
    },
  },

  getters: {
    displayedProducts: (state) => {
      return state.filteredProducts.length > 0
        ? state.filteredProducts
        : state.products;
    },
  },
};

export default products;
